<script>
import Drawer from "@/components/atoms/Drawer";
import RailHeightFilterButton from "@/components/atoms/RailHeightFilterButton";
import TSlotFilterButton from "@/components/atoms/TSlotFilterButton";
import ProfileFilterButton from "@/components/atoms/ProfileFilterButton";
import ConstructionFilterButton from "@/components/atoms/ConstructionFilterButton";
import ButtonToggle from "@/components/atoms/ButtonToggle";
import In from "@/components/atoms/In.vue";

export default {
  components: { In, Drawer, RailHeightFilterButton, TSlotFilterButton, ProfileFilterButton, ConstructionFilterButton, ButtonToggle },
  mounted(){
    this.search = this.$store.get('search_filter');
  },
  data(){
    return{
      search: "",
      pending_search: false,
      // part_category: null,
      // full_path: null
    }
  },
  // mounted(){
  //   this.part_category = this.$router.currentRoute.params.part_category
  //   this.full_path = this.$router.currentRoute.fullPath
  // },
  computed: {
    categoriesLegend(){
      return this.$store.get("parts/categoriesLegend");
    },
    categories(){
      if(this.$route.params.part_category && this.$store.get("parts/categoryById", this.$route.params.part_category)){
        return this.$store.get("parts/categoryById", this.$route.params.part_category).children.filter(child => (
          !child.match(/S_[0-9]+/g) && 
          child.toLowerCase() != "metric" && 
          child.toLowerCase() != "fractional" &&
          child.toLowerCase() != "imperial"
        ))
        // .filter(child => (
        //   this.$store.get("parts/categoryById", child) &&
        //   this.$store.get("parts/partsByCategoryUnfiltered", this.$store.get("parts/categoryById", child)).length > 0
        // ))
      }else{
        return this.categoriesLegend
        // .filter(id => (
        //   this.$store.get("parts/categoryById", id) &&
        //   this.$store.get("parts/partsByCategoryUnfiltered", this.$store.get("parts/categoryById", id)).length > 0
        // ));
      }
    },
    categoriesPath(){
      if(this.$route.fullPath && this.$route.fullPath.includes("categories/")){
        return this.$route.fullPath.split("categories/")[1].split("/id/")[0].split("/");
      }else{
        return []
      }
    }
  },
  methods: {
    hasPath(path_name){
      return !!this.$router.currentRoute.matched.find(route => route.name == path_name)
    },
    onClick(path){
      this.$router.push(path);
    },
    goToCategory(categoryId){
      if(this.$route.fullPath.includes("parts/categories")){
        this.$router.push((this.$route.fullPath+"/"+categoryId).replace("//", "/"))
      }else{
        this.$router.push(("/parts/categories/"+categoryId).replace("//", "/"))
      }
    }
  },
  watch: {
    // $route (to, from){
    //   this.part_category = this.$router.currentRoute.params.part_category
    //   this.full_path = this.$router.currentRoute.fullPath
    // },
    search(){
      if(!this.search){
        this.$store.commit('search_filter', this.search)
      }else{
        if(!this.pending_search){
          this.pending_search = true;
          setTimeout(()=>{
            this.$store.commit('search_filter', this.search)
            if(this.search.length > 1){
              this.$router.push("/parts/categories/")
              // this.$store.commit("clearFilters");
            }
            this.pending_search = false;
          }, 600)
        }
      }
    }
  }
};
</script>


<template>
  <div id="parts-page">
    <Drawer>
      <template v-slot:drawer> 
        <div class="parts-drawer">
          <div class="search-area">
            <in v-model="search" class="input" icon="fa-search" :clear="true"></in>
          </div>
          <div class="bread-crumbs" :class="{details: $route.params.part_id}">
            <template  v-if="hasPath('Parts')">
              <span class="link" :class="{active: $router.currentRoute.name == 'PartCategories'}" @click="() => onClick('/parts/categories')">
                All Parts
              </span>
              <template v-for="(path, index) in categoriesPath" v-if="$store.get('parts/categoryById', path)">
                <span class="divider">/</span>
                <span class="link" :class="{active: path == $route.params.part_category}" @click="() => onClick($route.fullPath.split(path)[0]+path)">
                  {{$store.get("parts/categoryById", path).name}}
                </span>
              </template >
              <template v-if="$route.params.part_id">
                <span class="divider">/</span>
                <span class="link" :class="{active: true}">
                  {{$route.params.part_id}}
                </span>
              </template >
            </template >
          </div>
          <div class="filters">
            <div class="filter" v-if="categories.length > 0">
              <div class="filter-title">
                Categories
              </div>
              <div class="filter-links">
                <div v-for="(categoryId, index) in categories" v-if="$store.get('parts/categoryById', categoryId) && $store.get('parts/partsByCategoryUnfiltered', $store.get('parts/categoryById', categoryId)).length > 0" :key="index" :class="{'active': $route.params.part_category == categoryId}" class="link" @click="() => goToCategory(categoryId)">
                  {{$store.get('parts/categoryById', categoryId).name}}
                </div>
              </div>
            </div>
            <div class="filter">
              <div class="filter-title">
                Units
              </div>
              <div class="toggle">
                <ButtonToggle left="Imperial" right="Metric" :default="$store.get('useMetric') ? 'Metric' : 'Imperial'" @select="(value) => $store.set('useMetric', value == 'Metric')"></ButtonToggle>
              </div>
            </div>
            <div class="filter low">
              <div class="filter-title">
                Series
              </div>
              <div class="filter-button-group">
                <template v-if="$store.get('useMetric') != true">
                  <TSlotFilterButton value="10" />
                  <TSlotFilterButton value="15" />
                </template>
                <template v-if="$store.get('useMetric') == true">
                  <TSlotFilterButton value="20" />
                  <TSlotFilterButton value="25" />
                  <TSlotFilterButton value="30" />
                  <TSlotFilterButton value="40" />
                  <TSlotFilterButton value="45" />
                </template>
              </div>
            </div>
          </div>
          <div class="filters" v-if="$route.fullPath.includes('T-SlottedProfiles')">
            <div class="filters-title" v-if="false">
              <div class="filter-count" @click="$store.set('clearFilters')"><span class="fal fa-times"></span>Clear</div>
            </div>
            <div class="filter" v-if="false">
              <div class="filter-title">
                Rail Height
              </div>
              <div class="filter-button-group">
                <template v-if="$store.get('useMetric') != true">
                  <RailHeightFilterButton value='1"' />
                  <RailHeightFilterButton value='1.5"' />
                  <RailHeightFilterButton value='2"' />
                  <RailHeightFilterButton value='3"' />
                  <RailHeightFilterButton value='4"' />
                  <RailHeightFilterButton value='4.5"' />
                </template>
                <template v-if="$store.get('useMetric') == true">
                  <RailHeightFilterButton value='20mm' />
                  <RailHeightFilterButton value='30mm' />
                  <RailHeightFilterButton value='40mm' />
                  <RailHeightFilterButton value='45mm' />
                  <RailHeightFilterButton value='60mm' />
                  <RailHeightFilterButton value='80mm' />
                  <RailHeightFilterButton value='90mm' />
                  <RailHeightFilterButton value='120mm' />
                  <RailHeightFilterButton value='160mm' />
                </template>
              </div>
            </div>
            <div class="filter">
              <div class="filter-title">
                Profiles
              </div>
              <div class="filter-icon-group">
                <ProfileFilterButton value="Single" width="2rem"/>
                <ProfileFilterButton value="Double" width="4rem"/>
                <ProfileFilterButton value="Quad" width="4rem"/>
                <ProfileFilterButton value="Multi" width="6rem"/>
              </div>
            </div>
            <div class="filter">
              <div class="filter-title">
                Construction
              </div>
              <div class="filter-icon-group">
                <ConstructionFilterButton value="Solid" />
                <ConstructionFilterButton value="Light-Weight" />
                <ConstructionFilterButton value="Ultra-Light-Weight" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:page>
        <router-view></router-view>
      </template>
    </Drawer>
  </div>
</template>

<style lang="scss">
@import "~@/styles/constants";
#parts-page {
  height: 100%;
  position: relative;
  .parts-drawer{
    padding-bottom: 2rem;
    .search-area{
      padding: 1.5rem 1.5rem 2rem 1.5rem;
    }
    .filters{
      padding-bottom: 0.5rem;
      .filters-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2rem 2rem 0rem 2rem;
        font-size: 1.5rem;
        height: 4rem;
        .filter-count{
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.25rem;
          font-weight: 400;
          border-radius: 0.5rem;
          border: 1px solid #FFF;
          padding: 0.5rem 1rem;
          &:hover, &.hover{
            background-color: $black_4;
            cursor: pointer;
          }
          * {
            pointer-events: none;
          }
          .fal{
            margin-right: 0.5rem;
          }
        }
      }
      .toggle{
        padding-left: 1rem;
      }
      .filter{
        padding: 0.5rem 0.5rem 1rem 0.5rem;
        &.low{
          // padding: 0.5rem 1rem 0rem 1.5rem;
        }
        .filter-title{
          font-size: 1.25rem;
          padding: 0.5rem 1rem 0.125rem 1rem;
          color: $w_1;
        }
        .filter-links{
          padding-top: 0.5rem;
          padding-left: 1rem;
          padding-right: 1rem;
          .link{
            font-size: 1.25rem;
            color: #FFF;
            padding: 0.75rem 1rem;
            border-radius: 0.25rem;
            display: flex;
            align-items: center;
            &:hover, &.hover{
              background-color: $black_4;
              cursor: pointer;
            }
            &.active{
              background-color: $p;
            }
          }
        }
        .filter-button-group{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          padding-left: 1rem;
          .filter-button{
            font-size: 1.25rem;
            color: #FFF;
            padding: 1rem 1.5rem;
            margin: 0.125rem;
            border-radius: 0.25rem;
            &:hover, &.hover{
              background-color: $black_4;
            }
            * {
              pointer-events: none;
            }
            &.active{
              background-color: $p;
            }
            &.small{
              padding: 0.5rem 1rem;
            }
          }
        }
        .filter-icon-group{
          .filter-icon{
            color: #FFF;
            padding: 1rem 2rem;
            border-radius: 0.25rem;
            display: flex;
            align-items: center;
            &:hover, &.hover{
              background-color: $black_4;
            }
            * {
              pointer-events: none;
            }
            &.active{
              background-color: $p;
            }
            .icon-label{
              font-size: 1.25rem;
              padding: 0rem 1.5rem;
            }
          }
        }
      }
    }
  }
  .bread-crumbs{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0rem 1rem 1rem 1rem;
    font-size: 1.25rem;
    .divider{
      color: #AAA;
    }
    .link{
      margin: 0rem 0.5rem;
      padding: 0.5rem 0.5rem;
      color: #FFF;
      
      overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      border-radius: 0.25rem;
      &.active{
        color: $w;
        background-color: $p;
        padding: 0.5rem 1rem;
      }
      &:not(.active){
        &:hover, &.hover{
          background-color: $black_4;
          cursor: pointer;
          border-radius: 0.5rem;
        }
      }
      * {
        pointer-events: none;
      }
    }
  }
}
</style>

